import {L} from '../utils';

export default {
	support: {
		name: L('Support'),
		what: L('сообществе'),
		addr: '/soo/support'
	}
};
